import { createTheme } from '@mui/material/styles'

const BRAND_BLUE  = '#173A5E'
const BRAND_GREEN = '#006400'
const LIGHT_GREEN = '#E8F5E9'

const theme = createTheme({
    palette: {
        background: {
            paper:             '#ffffff',
            default:           '#f7f8fa',
            transulscentDark:  '#212121B3',
            lightSecondary:    '#fafafa',
        },
        primary: {
            main:        BRAND_GREEN,
            light:       LIGHT_GREEN,
            contrastText:'#ffffff',
        },
        text: {
            primary:      BRAND_BLUE,
            primaryLight: '#F5F5F5',
            secondary:    '#46505A',
            primaryGreen: BRAND_GREEN,
            dimGrey:      '#8A9099',
        },
        divider: '#E3E8EF',
    },

    typography: {
        fontFamily: [
            '"Inter"',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
        ].join(','),
        fontSize: 14,

        h1: { fontWeight: 700, fontSize: '2.25rem',  lineHeight: 1.25, color: BRAND_BLUE },
        h2: { fontWeight: 700, fontSize: '1.875rem', lineHeight: 1.3,  color: BRAND_BLUE },
        h3: { fontWeight: 600, fontSize: '1.5rem',   lineHeight: 1.35, color: BRAND_BLUE },
        h4: { fontWeight: 600, fontSize: '1.25rem',  lineHeight: 1.4,  color: BRAND_BLUE },
        h5: { fontWeight: 600, fontSize: '1.125rem', lineHeight: 1.45, color: BRAND_BLUE },
        h6: { fontWeight: 600, fontSize: '1rem',     lineHeight: 1.5,  color: BRAND_BLUE },

        body1: { fontSize: '0.9375rem', lineHeight: 1.65, color: '#2D3748' },
        body2: { fontSize: '0.875rem',  lineHeight: 1.6,  color: '#4A5568' },

        subtitle1: { fontWeight: 500, fontSize: '0.9375rem', color: BRAND_BLUE },
        subtitle2: { fontWeight: 500, fontSize: '0.8125rem', color: '#46505A' },

        caption:   { fontSize: '0.75rem', color: '#8A9099', letterSpacing: '0.01em' },
        overline:  { fontSize: '0.6875rem', letterSpacing: '0.1em', fontWeight: 600, textTransform: 'uppercase' },

        button: { fontWeight: 600, letterSpacing: '0.03em', textTransform: 'none' },
    },

    shape: { borderRadius: 8 },

    shadows: [
        'none',
        '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04)',
        '0 3px 8px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.05)',
        '0 6px 18px rgba(0,0,0,0.08), 0 2px 6px rgba(0,0,0,0.04)',
        '0 10px 28px rgba(0,0,0,0.09), 0 3px 9px rgba(0,0,0,0.05)',
        '0 14px 35px rgba(50,50,93,0.10), 0 5px 15px rgba(0,0,0,0.07)',
        ...Array(19).fill('none'),
    ],

    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    backgroundColor: '#ffffff',
                    boxShadow: '0 1px 0 #E3E8EF',
                    color: BRAND_BLUE,
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 6,
                    padding: '7px 18px',
                    fontWeight: 600,
                    textTransform: 'none',
                    fontSize: '0.875rem',
                    letterSpacing: '0.02em',
                },
                contained: {
                    boxShadow: 'none',
                    '&:hover': { boxShadow: '0 2px 8px rgba(0,100,0,0.25)' },
                },
                text: { '&:hover': { backgroundColor: LIGHT_GREEN } },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 10,
                    boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
                },
            },
        },
        MuiTextField: {
            defaultProps: { size: 'small' },
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 6,
                        fontSize: '0.9rem',
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: { root: { fontSize: '0.875rem' } },
        },
        MuiChip: {
            styleOverrides: {
                root: { fontWeight: 600, fontSize: '0.75rem', borderRadius: 4 },
            },
        },
        MuiDivider: {
            styleOverrides: { root: { borderColor: '#E3E8EF' } },
        },
        MuiListItemText: {
            styleOverrides: {
                primary: { fontSize: '0.9375rem', fontWeight: 500, color: BRAND_BLUE },
            },
        },
        MuiPagination: {
            styleOverrides: {
                root: { display: 'flex', justifyContent: 'center' },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: { width: 260, paddingTop: 8 },
            },
        },
    },
})

export default theme
